import React from "react";
import "./ProcessHero.scss";

import { motion } from "framer-motion";

import { ReactComponent as HeroBtnTag } from "../../assets/svg/heroBtnTag.svg";
import { ReactComponent as HeroScroll } from "../../assets/svg/hero-scroll-btn.svg";
const scrollToSection = () => {
  const section = document.getElementById("processSection");
  const offsetTop = section.offsetTop;

  // Scroll to the top of the section with smooth animation
  window.scrollTo({
    top: offsetTop,
    behavior: "smooth",
  });
};

const ProcessHero = () => {
  return (
    <section className="section processHero">
      <article className="processHero__container container">
        <div className="processHero__container--contents">
          <motion.button
            type="button"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1 }}
          >
            <motion.span
              initial={{ y: 20, opacity: 0, scale: 1.15 }}
              animate={{ y: 0, opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.6 }}
            >
              Our Process
            </motion.span>

            <motion.div
              initial={{ y: 20, opacity: 0, scale: 1.15 }}
              animate={{ y: 0, opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.6 }}
            >
              <HeroBtnTag />
            </motion.div>
          </motion.button>

          <motion.h2
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            A Process
          </motion.h2>
          <motion.h3
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, delay: 0.4 }}
          >
            — With You in Mind...
          </motion.h3>
          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.3, delay: 1.2 }}
          >
            We embrace an effective design process that ensures flawless
            execution and delivers optimal outcomes, perfectly aligning our
            efforts with your vision.
          </motion.p>
        </div>
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1, delay: 0.8 }}
        >
          <HeroScroll
            className="processHero__container--scroll-btn"
            onClick={scrollToSection}
          />
        </motion.div>
      </article>
    </section>
  );
};

export default ProcessHero;
